import { render, staticRenderFns } from "./MemberNote.vue?vue&type=template&id=56fd6144&scoped=true&"
import script from "./MemberNote.vue?vue&type=script&lang=js&"
export * from "./MemberNote.vue?vue&type=script&lang=js&"
import style0 from "./MemberNote.vue?vue&type=style&index=0&id=56fd6144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd6144",
  null
  
)

export default component.exports